import React from 'react';
import { reduxForm } from 'redux-form';

import Button from 'jbc-front/components/Button';
import { Section, TextField } from 'src/jbc-front/components/Form';

import { CLIENT_COMMUTING_FEE_SETTING_FORM } from 'src/constants/FormNames';

import { isMoneyNumber } from 'src/utils/CustomValidators';
import { FormErrors } from 'src/components';
import { useTranslation } from 'react-i18next';

const ClientCommutingFeeSettingForm = ({ errors, submit, invalid, pristine, submitting, handleSubmit }) => {
  const { t } = useTranslation();
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FormErrors errors={errors} />

        <Section>
          <p className="u-mb10">{t('features.ClientCommutingFeeSetting.components.ClientCommutingFeeSettingForm.You_can_set_an_upper_limit_for_commuting_allowance_provided_for_using_train_and_bus')}</p>
          <p className="u-mb10">
            {t('features.ClientCommutingFeeSetting.components.ClientCommutingFeeSettingForm.The_commuting_allowance_paid_with_salary_is_calculated_automatically_based_on_employee_information')}<br />{t('features.ClientCommutingFeeSetting.components.ClientCommutingFeeSettingForm.With_this_setting_any_commuting_allowance_that_exceeds_the_upper_limit_will_be_changed_to_the_upper_limit_amount')}
          </p>
          <p className="u-mb10">
            {t('features.ClientCommutingFeeSetting.components.ClientCommutingFeeSettingForm.The_upper_limit_can_be_set_for_each_payment_unit_of_1_month_3_months_and_6_months_For_monthly_payment_depending_on_number_of_days_worked_the_upper_limit_of_1_month_is_applied')}
          </p>
          <ul className="m-list-notes u-mb20">
            <li>※{t('features.ClientCommutingFeeSetting.components.ClientCommutingFeeSettingForm.sujected_commuting_means_are_limited_to_train_and_bus_and_not_car')}</li>
            <li>※{t('features.ClientCommutingFeeSetting.components.ClientCommutingFeeSettingForm.Not_applicable_if_the_payment_method_is_in_kind')}</li>
          </ul>

          <TextField label={t('features.Employees.components.CommutingsSection.1_month')} name="maximumAmountPerMonth" yen validate={isMoneyNumber} />
          <TextField label={t('features.Employees.components.CommutingsSection.3_months')} name="maximumAmountPer3Months" yen validate={isMoneyNumber} />
          <TextField label={t('features.Employees.components.CommutingsSection.6_months')} name="maximumAmountPer6Months" yen validate={isMoneyNumber} />
          <div className="u-ta-c u-mt40">
            <Button disabled={pristine || submitting || invalid} onClick={submit} primary>
              {t('features.EmployeeBonus.components.ActionButtonSection.save')}
            </Button>
          </div>
        </Section>
      </form>
    </div>
  );
};

export default reduxForm({
  form: CLIENT_COMMUTING_FEE_SETTING_FORM
})(ClientCommutingFeeSettingForm);
